import { render, staticRenderFns } from "./RoleNameContextBody.vue?vue&type=template&id=6c34e4fe&scoped=true"
import script from "./RoleNameContextBody.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleNameContextBody.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RoleNameContextBody.vue?vue&type=style&index=0&id=6c34e4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34e4fe",
  null
  
)

export default component.exports